// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"f6yhtVyMv5m6lNgzKefTs","spaceLeft":"_1oW9vs1Guq7QcDyXBoX2rT","spaceBoth":"iOGHKqUXVa5LgSfzPoQCB","spaceRight":"q1GSI5iGDE58M9Gt2cQeH","table":"mibJgKNhCqzdZjH-MXVGJ","tradesHistory":"_3pitFoil6B0qdxEDG44TTk","select":"_1c1QJ39BwUsOQlfcot5sYS","openOffers":"v6SOv8tUn1XVxInc8d_Yk","info":"cgT9YwM7VrKQk3n81_5a9","cancelButton":"_1vDePmesBtIj5RJQDltsg5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisMyOrders.scss
// module id = 1265
// module chunks = 0